export default __webpack_public_path__ + "static/media/cou_yuan_bg.a5f2eb9b.png";